export default "__VITE_ASSET__DHOJlNBV__"